module.exports = __webpack_public_path__ + "img/blue_100.0cd380c2.png";